import VxeFormGatherComponent from '../form/src/form-gather';
import { dynamicApp } from '../dynamics';
export var VxeFormGather = Object.assign(VxeFormGatherComponent, {
    install: function (app) {
        app.component(VxeFormGatherComponent.name, VxeFormGatherComponent);
    }
});
export var FormGather = VxeFormGather;
dynamicApp.component(VxeFormGatherComponent.name, VxeFormGatherComponent);
export default VxeFormGather;
